<template>
  <div class="layout">
    <!-- 顶部导航 -->
    <SiteHeader  :is_login_page="false"/>

    <!-- 搜索栏 -->
    <div class="content">
      
        <div class="tag_search" @click="navigateToTagSearch">标签检索师资</div>
        <div class="ai_search" @click="navigateToAiSearch">AI检索师资</div>

    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/SiteFooter.vue';
import SiteHeader from '@/components/SiteHeader.vue';
export default {
  name: 'LayoutComponent',
  components: {
    SiteFooter,
    SiteHeader
  },
  data() {
    return {
     
    };
  },
  computed: {
  },
  created(){
  },
  methods: {
    navigateToTagSearch() {
      // 方式1: 使用路由跳转（推荐）
      this.$router.push('/home');

    },
    navigateToAiSearch() {
      // 方式1: 使用路由跳转（推荐）
      this.$router.push('/StreamResponse');
      
    }
  },
};
</script>

<style scoped>
  * { 
    margin: 0; 
    padding: 0; 
    box-sizing: border-box; 
  }
  body{
    margin:0; 
    padding:0; 
    box-sizing: border-box; 
    background-color: #F5F5F5;
  }
  .layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh; /* 确保至少占据整个视口高度 */
    height: 100vh; /* 精确占据整个视口高度 */
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
  }
  .content{
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap:100px;
    background-color: #F5F5F5;
    padding-bottom: 92px;
    height: 522px;
  }
  .tag_search{
    width: 300px;
    height: 300px;
    border: 2px solid #dddddd;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
    cursor: pointer; /* 添加这行使鼠标变成小手 */
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 
                0 6px 6px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.3s ease;
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 400;
    font-size: 26px;
    color: rgba(33, 150, 243, 0.8);
    line-height: 46px;
  }
  .ai_search{
    width: 300px;
    height: 300px;
    border: 2px solid #dddddd;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
    cursor: pointer; /* 添加这行使鼠标变成小手 */
    transition: box-shadow 0.3s ease;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 
                0 6px 6px rgba(0, 0, 0, 0.05);
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 400;
    font-size: 26px;
    color: rgba(33, 150, 243, 0.8);
    line-height: 46px;
  }
  .tag_search:hover, .ai_search:hover {
    /* box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); */
    
    /* 霓虹效果悬停 */
    box-shadow: 0 0 15px rgba(33, 150, 243, 0.8);
}
</style>